import React from 'react';
import Numbers from '../../classes/Numbers';
import InputAny from './InputAny';

interface IProps {
  id: string,
  value: number | string,
  callBack: any,
  dp: number
}

export default (props: IProps) =>
  <InputAny
    id={`input-${props.id}`}
    type="text"
    value={props.value}
    callBack={props.callBack}
    parse={parseFloat}
    cast={(value) => Numbers.isNumber(value) ? Number(value).toFixed(props.dp) : ''}
  />